import { http, HttpResponse } from 'msw';
import { PlessService } from '../../app/shared/pless-service.model';
import { ResponseUtils } from './response-utils';

export const kymw7001Handlers = [
  // 表紙特集商品選定情報承認 /kymw70/approvalFeatureInfo
  http.post(PlessService.SERVICE.approvalFeatureInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.approvalFeatureInfo.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集商品選定チェック /kymw70/checkFeatureGoodsSelection
  http.post(PlessService.SERVICE.checkFeatureGoodsSelection.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.checkFeatureGoodsSelection.url, req);
    return HttpResponse.json(checkFeatureGoodsSelectionResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 表紙特集商品選定情報確定 /kymw70/confirmFeatureGoodsByBuyer
  http.post(PlessService.SERVICE.confirmFeatureGoodsByBuyer.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.confirmFeatureGoodsByBuyer.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 特集情報一覧取得 /kymw70/getFeatureList
  http.post(PlessService.SERVICE.KYMW70getFeatureList.url,async ({ request }) => {
      const req = await request.json();
      console.log(PlessService.SERVICE.KYMW70getFeatureList.url, req);
      return HttpResponse.json(getFeatureListResponse);
      // return ResponseUtils.getSysError();
      // return ResponseUtils.getE0100();
      // return ResponseUtils.get500();
    }
  ),

  // 特集情報取得 /kymw70/getFeatureThemaByBuyer
  http.post(PlessService.SERVICE.getFeatureThemaByBuyer.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getFeatureThemaByBuyer.url, req);
    return HttpResponse.json(getFeatureThemaByBuyerResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品計画数予測取得 /kymw70/getGoodsPlanNum
  http.post(PlessService.SERVICE.KYMW70getGoodsPlanNum.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW70getGoodsPlanNum.url, req);
    return HttpResponse.json(getGoodsPlanNumResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 媒体リスト取得 /kymw70/getMediumListByOrder
  http.post(PlessService.SERVICE.KYMW70getMediumListByOrder.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW70getMediumListByOrder.url, req);
    return HttpResponse.json(getMediumListByOrderResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 代替商品情報取得 /kymw70/getReplacementGoods
  http.post(PlessService.SERVICE.getReplacementGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getReplacementGoods.url, req);
    return HttpResponse.json(getReplacementGoodsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 差し替え対象一覧取得 /kymw70/getReplacementList
  http.post(PlessService.SERVICE.getReplacementList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getReplacementList.url, req);
    // return HttpResponse.json(getReplacementListResponse);
    return HttpResponse.json(getReplacementListResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 代替依頼商品情報取得 /kymw70/getReplacementRequestGoods
  http.post(PlessService.SERVICE.getReplacementRequestGoods.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getReplacementRequestGoods.url, req);
    return HttpResponse.json(getReplacementRequestGoodsResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  

  // 表紙特集選定商品一覧取得 /kymw70/getSelectionGoodsListByBuyer
  http.post(PlessService.SERVICE.getSelectionGoodsListByBuyer.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getSelectionGoodsListByBuyer.url, req);
    return HttpResponse.json(getSelectionGoodsListByBuyerResponse);
    // return HttpResponse.json(getSelectionGoodsListByBuyerResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 商品情報取得(表紙特集掲載商品選定) /kymw70/getTargetListByFeatureGoodsSelection
  http.post(PlessService.SERVICE.KYMW70getTargetListByFeatureGoodsSelection.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW70getTargetListByFeatureGoodsSelection.url, req);
    return HttpResponse.json(getTargetListByFeatureGoodsSelectionResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 選定依頼登録 /kymw70/registFeatureRequestBuyer
  http.post(PlessService.SERVICE.registFeatureRequestBuyer.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.registFeatureRequestBuyer.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 表紙特集商品選定情報却下 /kymw70/rejectionFeatureInfo
  http.post(PlessService.SERVICE.rejectionFeatureInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.rejectionFeatureInfo.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

];

// 特集商品選定チェック
const checkFeatureGoodsSelectionResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "PCode": "P0000001",
        "ItemCode": "0000001"
      },
      {
        "PCode": "P0000002",
        "ItemCode": "0000002"
      }
    ]
  }
}

// 特集情報一覧取得結果
const getFeatureListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "FeatureCode": "T1",
        "FeatureName": "特集名1"
      },
      {
        "FeatureCode": "T2",
        "FeatureName": "特集名2"
      },
      {
        "FeatureCode": "T3",
        "FeatureName": "特集名3"
      },
      {
        "FeatureCode": "T4",
        "FeatureName": "特集名4"
      },
      {
        "FeatureCode": "T5",
        "FeatureName": "特集名5"
      },
    ]
  }
}

// 特集情報取得結果
const getFeatureThemaByBuyerResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      "Memo": "特集メモ"
    }
  }
}

// 商品計画数予測取得
const getGoodsPlanNumResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      "PlanNumList": [
        {
          "Pcode": "P0000010",
          "PlanNumAiPrediction": "2000"
        }
      ]
    }
  }
}

// 媒体リスト取得
const getMediumListByOrderResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "MediumType": "001",
        "MediumName": "媒体名1"
      },
      {
        "MediumType": "002",
        "MediumName": "媒体名2"
      }
    ]
  }
}

// 代替商品情報取得
const getReplacementGoodsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "FeatureCode": "T1",
        "FeatureName": "特集名1",
        "ClassCode": "010",
        "ClassName": "部門名1",
        "MiddleClassCode": "01",
        "MiddleClassName": "中分類名1",
        "PCode": "P0000001",
        "StockNum": "1000",
        "ItemCode": "0000001",
        "GuideGoodsName": "商品名商品名商品名商品名",
        "GuideStandardName": "規格名1",
        "PricePattern": "0",
        "ThisTimeSupplyPrice": "400",
        "ThisTimeCostPrice": "200",
        "PredictPlanNum": "2000",
        "PlanNum": "2000",
        "PlanSupplyBudget": "800000",
        "TagName": "秋",
        "Remarks": "9月30締切",
        "SelectorType": "1",
        "BuyerRequestId": ""
      },
    ]
  }
}

const getReplacementListResponseEmpty = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: []
  }
}

// 差し替え対象一覧取得
const getReplacementListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "RequestBuyer": "00100001",
        "FeatureCode": "T1",
        "FeatureName": "特集名1特集名1",
        "ClassCode": "010",
        "ClassName": "部門名1部門名1",
        "MiddleClassCode": "01",
        "MiddleClassName": "中分類名1中分類名1",
        "PCode": "P0000001",
        "GuideGoodsName": "商品名商品名商品名商品名商品名",
        "GuideStandardName": "規格名1",
        "PricePattern": "0",
        "ThisTimeSupplyPrice": "400",
        "ThisTimeCostPrice": "200",
        "PredictPlanNum": "2000",
        "PlanNum": "2000",
        "PlanSupplyBudget": "800000",
        "TagName": "秋",
        "Remarks": "9月30締切",
        "RequestStatus": "0",
        "BuyerRequestId": "",
      },
      {
        "RequestBuyer": "00100002",
        "FeatureCode": "T1",
        "FeatureName": "特集名1",
        "ClassCode": "010",
        "ClassName": "部門名1",
        "MiddleClassCode": "02",
        "MiddleClassName": "中分類名2",
        "PCode": "P0000002",
        "GuideGoodsName": "商品名2",
        "GuideStandardName": "規格名2",
        "PricePattern": "1",
        "ThisTimeSupplyPrice": "600",
        "ThisTimeCostPrice": "400",
        "PredictPlanNum": "4000",
        "PlanNum": "6000",
        "PlanSupplyBudget": "1000000",
        "TagName": "秋",
        "Remarks": "備考",
        "RequestStatus": "1", 
        "BuyerRequestId": "",        
      },
      {
        "RequestBuyer": "00100003",
        "FeatureCode": "T1",
        "FeatureName": "特集名1",
        "ClassCode": "030",
        "ClassName": "部門名3",
        "MiddleClassCode": "03",
        "MiddleClassName": "中分類名3",
        "PCode": "P0000003",
        "GuideGoodsName": "商品名3",
        "GuideStandardName": "規格名3",
        "PricePattern": "2",
        "ThisTimeSupplyPrice": "600",
        "ThisTimeCostPrice": "400",
        "PredictPlanNum": "4000",
        "PlanNum": "6000",
        "PlanSupplyBudget": "1100000",
        "TagName": "春",
        "Remarks": "備考備考備考備考",
        "RequestStatus": "2", 
        "BuyerRequestId": "",        
      },
      {
        "RequestBuyer": "",
        "FeatureCode": "T1",
        "FeatureName": "特集名1特集名1",
        "ClassCode": "040",
        "ClassName": "部門名4",
        "MiddleClassCode": "04",
        "MiddleClassName": "中分類名4",
        "PCode": "P0000004",
        "GuideGoodsName": "商品名4",
        "GuideStandardName": "規格名4",
        "PricePattern": "3",
        "ThisTimeSupplyPrice": "400",
        "ThisTimeCostPrice": "200",
        "PredictPlanNum": "2000",
        "PlanNum": "2000",
        "PlanSupplyBudget": "400000",
        "TagName": "春夏秋冬",
        "Remarks": "備考4",
        "RequestStatus": "0",
        "BuyerRequestId": "",
      },
    ]
  }
}

// 代替依頼商品情報取得
const getReplacementRequestGoodsResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "BuyerRequestId": "",
        "FeatureCode": "T1",
        "FeatureName": "特集名1",
        "ClassCode": "010",
        "ClassName": "部門名1",
        "MiddleClassCode": "01",
        "MiddleClassName": "中分類名1",
        "PCode": "P0000001",
        "ItemCode": "0000001",
        "GuideGoodsName": "商品名1",
        "GuideStandardName": "規格名1",
        "PricePattern": "0",
        "ThisTimeSupplyPrice": "400",
        "ThisTimeCostPrice": "200",
        "PredictPlanNum": "2000",
        "PlanNum": "2000",
        "PlanSupplyBudget": "800000",
        "TagName": "秋",
        "RequestStatus": "0",
        "Remarks": "9月30締切",
      },
      {
        "BuyerRequestId": "",
        "FeatureCode": "T1",
        "FeatureName": "特集名1",
        "ClassCode": "010",
        "ClassName": "部門名1",
        "MiddleClassCode": "02",
        "MiddleClassName": "中分類名2",
        "PCode": "P0000002",
        "ItemCode": "0000002",
        "GuideGoodsName": "商品名2",
        "GuideStandardName": "規格名2",
        "PricePattern": "1",
        "ThisTimeSupplyPrice": "600",
        "ThisTimeCostPrice": "400",
        "PredictPlanNum": "4000",
        "PlanNum": "5000",
        "PlanSupplyBudget": "800000",
        "TagName": "夏",
        "RequestStatus": "0",
        "Remarks": "備考",
      },
    ]
  }
}

const getSelectionGoodsListByBuyerResponseEmpty = {
  status: 'ok',
  message: '処理完了',
  "result": {
    "obj": []
    }
}

// 表紙特集選定商品一覧取得
const getSelectionGoodsListByBuyerResponse = {
  status: 'ok',
  message: '処理完了',
  "result": {
    "obj": [
      {
        "FeatureCode": "T1",
        "FeatureName": "特集名1",
        "ClassCode": "01",
        "ClassName": "部門名1部門名1",
        "MiddleClassCode": "01",
        "MiddleClassName": "中分類名1中分類名1",
        "PCode": "P0000001",
        "StockNum": "2000",
        "GuideGoodsName": "商品名商品名商品名商品名",
        "GuideStandardName": "規格名1",
        "PricePattern": "0",
        "IsChangedPricePattern": "1",
        "ThisTimeSupplyPrice": "400",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "IsChangedSupplyPrice": "0",
        "ThisTimeCostPrice": "200",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
        "IsChangedCostPrice": "0",
        "PredictPlanNum": "",
        "PlanNum": "",
        "IsChangedPlanNum": "0",
        "PlanSupplyBudget": "",
        "IsChangedPlanSupplyBudget": "0",
        "TagName": "春夏秋冬春夏秋冬",
        "Remarks": "備考備考備考備考備考",
        "SelectorType": "0",
        "BuyerRequestId": "0000000000001",
        "ItemCode": "0000001",
      },
      {
        "FeatureCode": "T1",
        "FeatureName": "特集名1",
        "ClassCode": "02",
        "ClassName": "部門名1",
        "MiddleClassCode": "01",
        "MiddleClassName": "中分類名1",
        "PCode": "P0000002",
        "StockNum": "2000",
        "GuideGoodsName": "商品名2",
        "GuideStandardName": "規格名2",
        "PricePattern": "1",
        "IsChangedPricePattern": "0",
        "ThisTimeSupplyPrice": "400",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "IsChangedSupplyPrice": "0",
        "ThisTimeCostPrice": "200",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
        "IsChangedCostPrice": "1",
        "PredictPlanNum": "300",
        "PlanNum": "2000",
        "IsChangedPlanNum": "0",
        "PlanSupplyBudget": "700000",
        "IsChangedPlanSupplyBudget": "0",
        "TagName": "春",
        "Remarks": "備考2",
        "SelectorType": "1",
        "BuyerRequestId": "0000000000001",
        "ItemCode": "0000001",
      },
      {
        "FeatureCode": "T1",
        "FeatureName": "特集名1",
        "ClassCode": "03",
        "ClassName": "部門名1",
        "MiddleClassCode": "01",
        "MiddleClassName": "中分類名1",
        "PCode": "P0000003",
        "StockNum": "2000",
        "GuideGoodsName": "商品名3",
        "GuideStandardName": "規格名3",
        "PricePattern": "2",
        "IsChangedPricePattern": "1",
        "ThisTimeSupplyPrice": "400",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "IsChangedSupplyPrice": "0",
        "ThisTimeCostPrice": "200",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
        "IsChangedCostPrice": "0",
        "PredictPlanNum": "300",
        "PlanNum": "2000",
        "IsChangedPlanNum": "0",
        "PlanSupplyBudget": "600000",
        "IsChangedPlanSupplyBudget": "1",
        "TagName": "夏",
        "Remarks": "備考3",
        "SelectorType": "2",
        "BuyerRequestId": "0000000000001",
        "ItemCode": "0000001",
      },
      {
        "FeatureCode": "T1",
        "FeatureName": "特集名1",
        "ClassCode": "04",
        "ClassName": "部門名1",
        "MiddleClassCode": "01",
        "MiddleClassName": "中分類名1",
        "PCode": "P0000004",
        "StockNum": "2000",
        "GuideGoodsName": "商品名4",
        "GuideStandardName": "規格名4",
        "PricePattern": "3",
        "IsChangedPricePattern": "0",
        "ThisTimeSupplyPrice": "400",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "IsChangedSupplyPrice": "0",
        "ThisTimeCostPrice": "200",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
        "IsChangedCostPrice": "0",
        "PredictPlanNum": "300",
        "PlanNum": "2000",
        "IsChangedPlanNum": "0",
        "PlanSupplyBudget": "500000",
        "IsChangedPlanSupplyBudget": "0",
        "TagName": "秋",
        "Remarks": "備考4",
        "SelectorType": "2",
        "BuyerRequestId": null,
        "ItemCode": "0000001",
      },
      {
        "FeatureCode": "T1",
        "FeatureName": "特集名1",
        "ClassCode": "04",
        "ClassName": "部門名1",
        "MiddleClassCode": "01",
        "MiddleClassName": "中分類名1",
        "PCode": "P0000005",
        "StockNum": "2000",
        "GuideGoodsName": "商品名5",
        "GuideStandardName": "規格名5",
        "PricePattern": "0",
        "IsChangedPricePattern": "0",
        "ThisTimeSupplyPrice": "400",
        "SupplyPriceStandard": "300",
        "SupplyPriceSpecial1": "200",
        "SupplyPriceSpecial2": "100",
        "IsChangedSupplyPrice": "0",
        "ThisTimeCostPrice": "200",
        "CostPriceStandard": "300",
        "CostPriceSpecial1": "150",
        "CostPriceSpecial2": "100",
        "IsChangedCostPrice": "0",
        "PredictPlanNum": "300",
        "PlanNum": "2000",
        "IsChangedPlanNum": "0",
        "PlanSupplyBudget": "400000",
        "IsChangedPlanSupplyBudget": "0",
        "TagName": "冬",
        "Remarks": "9月30締切",
        "SelectorType": "3",
        "BuyerRequestId": "0000000000001",
        "ItemCode": "0000001",
      },
    ]  
  }
}

// 商品情報取得(表紙特集掲載商品選定)
const getTargetListByFeatureGoodsSelectionResponse = {
  status: 'ok',
  message: '処理完了',
  "result": {
    "obj": [
      {
        "PCode": "P0000010",
        "ItemCode": "1234567",
        "GuideGoodsName": "商品名商品名商品",
        "GuideStandardName": "規格名1",
        "ClassCode": "01",
        "ClassNameKanji": "部門名部門名",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名大分類名",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "中分類名中分類名",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名小分類名",
        "TagName": "タグ名1、タグ名2、タグ名3、タグ名4"
      },
      {
        "PCode": "P0000011",
        "ItemCode": "1234568",
        "GuideGoodsName": "商品名2",
        "GuideStandardName": "規格名2",
        "ClassCode": "02",
        "ClassNameKanji": "部門名2",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名1",
        "MiddleClassCode": "002",
        "MiddleClassNameKanji": "中分類名2",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名1",
        "TagName": "タグ名1、タグ名2"
      },
      {
        "PCode": "P0000012",
        "ItemCode": "1234568",
        "GuideGoodsName": "予測値空",
        "GuideStandardName": "規格名2",
        "ClassCode": "03",
        "ClassNameKanji": "部門名3",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名1",
        "MiddleClassCode": "003",
        "MiddleClassNameKanji": "中分類名3",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名1",
        "TagName": "タグ名1、タグ名2"
      },
      {
        "PCode": "P0000013",
        "ItemCode": "1234568",
        "GuideGoodsName": "選定不可データ",
        "GuideStandardName": "取扱終了扱",
        "ClassCode": "02",
        "ClassNameKanji": "部門名2",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名1",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "中分類名1",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名1",
        "TagName": "タグ名1、タグ名2"
      },
      {
        "PCode": "P0000001",
        "ItemCode": "1234568",
        "GuideGoodsName": "選定不可データ",
        "GuideStandardName": "重複",
        "ClassCode": "02",
        "ClassNameKanji": "部門名2",
        "LargeClassCode": "001",
        "LargeClassNameKanji": "大分類名1",
        "MiddleClassCode": "001",
        "MiddleClassNameKanji": "中分類名1",
        "SmallClassCode": "001",
        "SmallClassNameKanji": "小分類名1",
        "TagName": "タグ名1、タグ名2"
      },
    ]
  }
}
